var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Envío de Información" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("InformacionGeneralForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: { modoVer: true, envio: _vm.envio }
          }),
          _c("AsociarFlotaEtiquetaVehiculoIndividual", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarVehiculos.step,
                expression: "pasoActivoIndex === pasos.asociarVehiculos.step"
              }
            ],
            attrs: {
              "flotas-id-seleccionar": _vm.envio && _vm.envio.flotas,
              "etiquetas-id-seleccionar": _vm.envio && _vm.envio.etiquetas,
              "vehiculos-id-seleccionar": _vm.envio && _vm.envio.vehiculos,
              readonly: true,
              "col-def-vehiculo": _vm.vehiculoColDefs
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }